<template>
  <div class="success">
    <img
      class="flowers"
      src="@/assets/flowers-left.webp"
      alt="colourful flowers"
    />
    <h4 class="header">Case Studies</h4>
    <p class="header-brief">
      Take a look at how I've helped clients achieve their marketing goals
      through tailored strategies.
    </p>
    <div class="flex">
      <div v-for="item in success" :key="item.title">
        <CaseStudyCard
          :title="item.title"
          :problem="item.problem"
          :solution="item.solution"
          :outcome="item.outcome"
          :roas="item.roas"
          :profitMargin="item.profitMargin"
          :image="item.image"
          :alt="item.alt"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CaseStudyCard from "@/components/CaseStudyCard.vue";
export default {
  components: {
    CaseStudyCard,
  },
  data() {
    return {
      success: [
        {
          title: "Excel Martial Arts - Paid Meta Ads Strategy",
          problem:
            "Wanting a clear lead generation process to grow student numbers.",
          solution:
            "A targeted Meta Ads campaign was developed to capture qualified leads, streamline the funnel from interest to assessment booking, and optimise conversions through performance tracking and tailored ad creatives, with 7 day lead nurture sequences.",
          outcome:
            "517% ROAS and a 418% net profit margin. The campaign transformed the student acquisition strategy, delivering immediate growth and a scalable model for future enrolments.",
          roas: "517%",
          profitMargin: "418%",
          image: "Excel.webp",
          alt: "Excel Martial Arts logo",
        },
        {
          title: "Hair Salon – Social Media Strategy",
          problem:
            "A local hair salon was facing declining customer numbers. Traditional marketing approaches were no longer resonating, and the brand struggled to connect with a younger demographic that drives repeat business and long-term loyalty.",
          solution:
            "A refreshed social media strategy repositioned the salon to appeal to a younger audience. Content was tailored to showcase modern styles, trending services, and behind-the-scenes authenticity, while engagement tactics built stronger connections with potential clients. The focus shifted from simply attracting more customers to increasing the value of each visit.",
          outcome:
            "200% increase in average customer spend per visit. Effectively tripled transaction value, boosting revenue without needing to expand the customer base. Social media presence repositioned the brand to appeal to a younger, higher-value demographic. Social platforms became a direct revenue driver rather than just an awareness tool. The strategy not only revitalised the salon's brand appeal but also transformed customer behaviour, generating sustainable revenue growth.",
          roas: "",
          profitMargin: "",
          image: "TaylorTaylorHair.webp",
          alt: "Hair Salon logo",
        },
        {
          title: "Sheffield Dog Training – Website & Digital Strategy",
          problem:
            "A dog training business owner believed demand for her services was disappearing, with bookings in decline and the perception that the industry itself was in decline. Her brand no longer resonated with potential customers, and digital presence was outdated and underperforming.",
          solution:
            "An integrated digital strategy was implemented, including a full website redevelopment, targeted email marketing campaigns, and a refreshed social media strategy to rebuild brand authority and re-engage the target audience. The focus was on creating a modern, accessible online experience while driving demand through consistent communication and targeted outreach.",
          outcome:
            "125% increase in bookings within the first month. Business repositioned to show clear customer demand and renewed growth potential. Email and social strategies boosted engagement and conversion rates across platforms with over 18k views in 3 months. Set to book out all classes by month two, creating sustainable demand and long-term momentum. This transformation not only disproved the idea of a 'dying industry' but also turned digital channels into the primary engine of growth for the business.",
          roas: "",
          profitMargin: "",
          image: "sheffield-dog-training.webp",
          alt: "Sheffield Dog Training logo",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.success {
  position: relative;
  background-color: #f1f6f8;
  padding: 30px 140px;
}

.flowers {
  position: absolute;
  top: -160px;
  left: 0;
  width: auto;
}

.header {
  text-align: center;
  color: #1c0a0a;
  font-size: 50px;
  font-weight: 700;
  line-height: 60px;
  margin-bottom: 20px;

  &-brief {
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: #584f49;
    width: 50%;
    margin: 0 auto 50px auto;
  }
}

.flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .header {
    font-size: 40px;
    &-brief {
      width: 80%;
    }
  }
  .success {
    position: relative;
    background-color: #f1f6f8;
    padding: 10px 0;
  }

  .flowers {
    display: none;
  }
}
</style>
